export class UpdateSapJobInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "SapJobStatus",
            "format": ""
        },
        {
            "name": "rowsExtracted",
            "baseName": "rowsExtracted",
            "type": "number",
            "format": ""
        },
        {
            "name": "bytesExtracted",
            "baseName": "bytesExtracted",
            "type": "number",
            "format": ""
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSapJobInput.attributeTypeMap;
    }
    constructor() {
    }
}
